// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/vue-table.scss
// module id = 197
// module chunks = 62